import { render } from "./ExtendView.vue?vue&type=template&id=7da7ba50&scoped=true"
const script = {}

import "./ExtendView.vue?vue&type=style&index=0&id=7da7ba50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da7ba50"]])

export default __exports__